import React, {
  useState,
  useRef,
  createRef,
  useCallback,
  useEffect,
  useImperativeHandle
} from 'react';
import dynamic from 'next/dynamic';
import { Input, Icon, Progress, message } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import less from './GeneralSpeechEvaluationItem.less';
import './GeneralSpeechEvaluationItem.css';
import account from '@/common/account/index';

const Recorder = dynamic(() => import('./Recorder'), { ssr: false });
const { TextArea } = Input;
message.config({
  duration: 1,
  maxCount: 1
});
let allChineseRegExp = /[\u4e00-\u9fa5]/g;
let allEnglishRegExp = /[a-zA-Z]/g;
let allNumberRegexp = /[0-9]/g;
let initProgressList = [
  {
    label: '总分',
    score: 0
  },
  {
    label: '流利分',
    score: 0
  },
  {
    label: '完整分',
    score: 0
  },
  {
    label: '发音分',
    score: 0
  }
];

const GeneralSpeechEvaluationItem = ({
  abilityContent,
  generalSpeechEvaluationRef
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [recordingStatus, setRecordingStatus] = useState(0); // 0未开始，1正在进行，2结束录音，3全部结果都已返回
  const [progressList, setProgressList] = useState([...initProgressList]);
  const [currentTitle, setCurrentTitle] = useState('请选择评测内容');
  const [activeText, setActiveText] = useState(abilityContent.result[0].result);
  const [newActiveText, setNewActiveText] = useState([
    ...abilityContent.result[0].result.split('')
  ]);
  const [activeTextColorList, setActiveTextColorList] = useState([]);
  const [customResult, setCustomResult] = useState({
    content: '',
    length: 0,
    status: true
  });
  const [audioUrl, setAudioUrl] = useState('');
  const [language, setLanguage] = useState(abilityContent.title);
  const [audio, setAudio] = useState({
    isPausing: true,
    ref: createRef()
  });
  const [progressPercent, setProgressPercent] = useState(0);
  const [currentTimes, setCurrentTimes] = useState('00:00');
  const [generalSpeechAudioDuration, setGeneralSpeechAudioDuration] =
    useState(0);
  const AudioRef = useRef();
  const customResultRef = useRef();

  const formatList = useCallback((list) => {
    let newList = [];
    for (let i = 0; i < list.length; i++) {
      if (list[i] !== '') {
        newList.push({
          text: list[i],
          score: 0,
          id: list[i] + i
        });
      }
    }
    return newList;
  }, []);

  const formatListByRegexp = useCallback(
    (list, regexp) => {
      for (let i = 0; i < list.length; i++) {
        if (!regexp.test(list[i])) {
          if (i !== 0) {
            list[i - 1] =
              regexp === '/[\u4e00-\u9fa5]/'
                ? list[i - 1] + list[i]
                : list[i - 1] + ' ' + list[i];
          }
          list[i] = undefined;
        }
      }
      let newList = list.filter(
        (item) => item !== undefined && item && item.indexOf('undefined') !== 0
      );
      return formatList(newList);
    },
    [formatList]
  );

  const formatWord = useCallback((word) => {
    let wordList = word.split('');
    for (let i = 1; i < wordList.length - 1; i++) {
      if (!/[a-z|\u0027]/.test(wordList[i])) {
        wordList[i] = ' ';
      }
    }
    return wordList.join('');
  }, []);

  const formatStr = useCallback(
    (str) => {
      str = str.replace(/[\s]+/g, ' '); // 移除多余空格
      let words = str.split(' ');
      let newWords = [];
      words.forEach((word) => {
        newWords.push(formatWord(word));
      });
      return newWords.join(' ');
    },
    [formatWord]
  );

  const startRecognise = useCallback(() => {
    setRecordingStatus(1);
    setCurrentTitle('评测音频录制');
    setCurrentTimes('00:00');
    setProgressPercent(0);
    AudioRef.current.start();
  }, [setRecordingStatus, setCurrentTitle]);

  const startWillRecorder = useCallback(
    (index) => {
      const loginEd = account.hasLoggedin();
      if (!loginEd) {
        window.location.href = `/account/login?from=${window.location.pathname}${window.location.search}`;
        return;
      }
      if (index === 4) {
        let _customResult = customResult.content.trim();
        if (_customResult !== '') {
          if (
            (language === '中文' &&
              (allEnglishRegExp.test(_customResult) ||
                allNumberRegexp.test(_customResult))) ||
            (language === '英文' &&
              (allChineseRegExp.test(_customResult) ||
                allNumberRegexp.test(_customResult)))
          ) {
            setCustomResult({
              ...customResult,
              ...{ status: false }
            });
          } else {
            setCurrentTitle('请点击录音，跟读文本');
            setActiveText(
              language === '中文' ? _customResult : formatStr(_customResult)
            );
          }
        } else {
          setCustomResult({
            ...customResult,
            ...{ status: false }
          });
        }
      } else {
        setCurrentTitle('请点击录音，跟读文本');
        setActiveText(abilityContent.result[index].result);
      }
    },
    [
      setCurrentTitle,
      setActiveText,
      setCustomResult,
      customResult,
      abilityContent.result,
      language,
      formatStr
    ]
  );

  const initGeneralSpeechEvaluation = useCallback(() => {
    AudioRef.current.stop();
    setCurrentIndex(0);
    setRecordingStatus(0);
    setProgressList([...initProgressList]);
    setCurrentTitle('请选择评测内容');
    setActiveText(abilityContent.result[0].result);
    setNewActiveText([...abilityContent.result[0].result.split('')]);
    setActiveTextColorList([]);
    setCustomResult({
      content: '',
      length: 0,
      status: true
    });
    setAudioUrl('');
    setLanguage(abilityContent.title);
    setAudio({
      isPausing: true,
      ref: createRef()
    });
    setProgressPercent(0);
    setCurrentTimes('00"00');
    setGeneralSpeechAudioDuration(0);
    customResultRef.current.state.value = '';
  }, [
    setCurrentIndex,
    setRecordingStatus,
    setProgressList,
    setCurrentTitle,
    setActiveText,
    setNewActiveText,
    setActiveTextColorList,
    setCustomResult,
    setAudioUrl,
    setLanguage,
    setAudio,
    setProgressPercent,
    setCurrentTimes,
    setGeneralSpeechAudioDuration,
    abilityContent.result,
    abilityContent.title
  ]);

  const startReEvaluating = useCallback(() => {
    initGeneralSpeechEvaluation();
  }, [initGeneralSpeechEvaluation]);

  const customResultChangeHandle = useCallback(
    (e) => {
      e.persist();
      if (e.target.value === '') {
        setCustomResult({
          ...customResult,
          ...{ status: false }
        });
        return;
      }
      setCustomResult({
        ...customResult,
        ...{
          status: true,
          content: e.target.value,
          length: e.target.value.length
        }
      });
    },
    [setCustomResult, customResult]
  );

  const audioControlHandle = useCallback(() => {
    const cAudio = _.cloneDeep(audio);
    cAudio.isPausing = !cAudio.isPausing;
    setAudio(cAudio);
    const currentDom = cAudio.ref.current;
    if (cAudio.isPausing) {
      currentDom.pause();
    } else {
      currentDom.play();
      cAudio.playTimer = setInterval(() => {
        if (currentDom.paused) {
          clearInterval(cAudio.playTimer);
          if (
            Math.floor(currentDom.currentTime) >=
            Math.floor(currentDom.duration)
          ) {
            cAudio.isPausing = true;
            setAudio(cAudio);
          }
        }
        setCurrentTimes(
          moment(Math.floor(currentDom.currentTime * 1000)).format('mm:ss')
        );
        setProgressPercent(
          Math.floor((currentDom.currentTime / currentDom.duration) * 100)
        );
      }, 300);
    }
  }, [setAudio, setCurrentTimes, setProgressPercent, audio]);

  const setActiveTextColor = useCallback(() => {
    let activeTextList =
      language === '中文'
        ? formatListByRegexp(activeText.split(''), /[\u4e00-\u9fa5]/)
        : formatListByRegexp(activeText.split(' '), /[a-zA-Z]/);
    if (activeTextList.length === newActiveText.length) {
      for (let i = 0; i < activeTextList.length; i++) {
        activeTextList[i].score = newActiveText[i].score || 0; // todo naming
      }
    }
    setActiveTextColorList([...activeTextList]);
  }, [activeText, newActiveText, language, formatListByRegexp]);

  const changeButtonCurrentIndexHandle = useCallback(
    (index) => {
      setCurrentIndex(index);
      setCustomResult({
        ...customResult,
        ...{ status: true }
      });
    },
    [setCurrentIndex, setCustomResult, customResult]
  );

  useImperativeHandle(generalSpeechEvaluationRef, () => ({
    init: () => {
      initGeneralSpeechEvaluation();
    }
  }));

  useEffect(() => {
    setActiveTextColor();
  }, [setActiveTextColor]);

  return (
    <>
      <div
        className={
          less.generalSpeechEvaluationItem +
          ' ' +
          (currentTitle !== '请选择评测内容'
            ? less.generalSpeechEvaluationSpecial
            : '')
        }
      >
        <div
          className={
            less.reEvaluating +
            ' ' +
            (currentTitle === '请选择评测内容' ? less.active : '')
          }
        >
          <button
            type="button"
            className={less.button}
            onClick={() => startReEvaluating()}
          >
            重新评测
          </button>
        </div>
        <p className={less.currentTitle}>{currentTitle}</p>
        <div
          className={
            less.initRecorder +
            ' ' +
            (currentTitle !== '请选择评测内容' ? less.hidden : '')
          }
        >
          <ul>
            {abilityContent.result.length > 0 &&
              abilityContent.result.map((item, index) => {
                return (
                  <li key={item.inx}>
                    <div className={less.li}>
                      <div className={less.liItem}>
                        <button
                          type="button"
                          onClick={() => changeButtonCurrentIndexHandle(index)}
                          className={
                            less.resultButton +
                            ' ' +
                            (currentIndex === index ? less.buttonActive : '')
                          }
                        >
                          {item.result}
                        </button>
                      </div>
                    </div>
                  </li>
                );
              })}
          </ul>
          <div
            className={less.customReviewContent}
            onClick={() => setCurrentIndex(4)}
          >
            <div
              className={
                less.customInner +
                ' ' +
                (currentIndex === 4 ? less.customReviewContentActive : '')
              }
            >
              <p className={less.title}>自定义评测内容</p>
              <div className={less.content}>
                <TextArea
                  ref={customResultRef}
                  maxLength={language === '中文' ? '40' : '60'}
                  autoSize="true"
                  placeholder="请输入你要评测的文本内容"
                  onChange={customResultChangeHandle}
                  className={
                    less.contentText +
                    ' ' +
                    (!customResult.status ? less.customResultError : '')
                  }
                />
              </div>
              {!customResult.status && (
                <p className={less.errorTip}>
                  {language === '中文'
                    ? '请输入需要评测的中文文本内容，只能输入汉字'
                    : '请输入需要评测的英文文本内容，只能输入英文'}
                </p>
              )}
              <div className={less.tip}>
                {customResult.length}/{language === '中文' ? '40' : '60'}
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            less.recordOuter +
            ' ' +
            (currentTitle === '请选择评测内容' ? less.hidden : '')
          }
        >
          <button
            type="button"
            className={less.resultButton + ' ' + less.buttonActive}
          >
            {currentTitle === '请点击录音，跟读文本' &&
            activeTextColorList.length === 0
              ? activeText
              : activeTextColorList.length > 0 &&
                activeTextColorList.map((item) => {
                  return (
                    <span
                      key={item.id}
                      style={
                        recordingStatus === 3 &&
                        parseInt(progressList[0].score, 0) < 30
                          ? { color: '#042044' }
                          : recordingStatus !== 3 && item.score === 0
                          ? { color: '#939393' }
                          : language === '中文'
                          ? item.score >= 40
                            ? { color: '#215B0E' }
                            : { color: '#D0021B' }
                          : item.score >= 50
                          ? { color: '#215B0E' }
                          : { color: '#D0021B' }
                      }
                    >
                      {language === '中文' ? item.text : item.text + ' '}
                    </span>
                  );
                })}
          </button>
          <p
            className={
              less.tipMessage +
              ' ' +
              (currentTitle === '请点击录音，跟读文本'
                ? less.marginBottomP
                : '')
            }
          >
            请朗读文本内容进行评测
          </p>
          <div
            className={
              currentTitle === '评测音频录制' || currentTitle === '评测结果'
                ? less.scoreProgressBar
                : less.scoreProgressBarDisplay
            }
          >
            {progressList.length > 0 &&
              progressList.map((progressItem) => {
                return (
                  <div
                    className={less.scoreProgressBarItem}
                    key={progressItem.label}
                  >
                    <div className={less.process}>
                      <Progress
                        className={less.progress}
                        strokeColor={{ '0%': '#5187D5', '100%': '#295DA8' }}
                        type="circle"
                        percent={
                          recordingStatus === 3 &&
                          parseInt(progressList[0].score, 0) < 30
                            ? 0
                            : Math.round(progressItem.score)
                        }
                        format={(percent) => `${percent}`}
                      />
                    </div>
                    <p className={less.label}>{progressItem.label}</p>
                  </div>
                );
              })}
          </div>
        </div>
        <p className={less.emphasis}>
          {recordingStatus === 3 && parseInt(progressList[0].score, 0) < 30 ? (
            <span className={less.uselessVoice}>无效语音，请按文本跟读</span>
          ) : (
            <span className={less.tip}>
              当前接口对<span>{language === '英文' ? '低幼' : ''}儿童语音</span>
              评测效果较好，成人语音评测可能会有差异
            </span>
          )}
        </p>
        <div className={less.recogniseButton}>
          <button
            type="button"
            className={
              less.button +
              ' ' +
              (currentTitle !== '请选择评测内容' ? less.hidden : '')
            }
            onClick={() => startWillRecorder(currentIndex)}
          >
            开始评测
          </button>
          <div
            className={
              less.buttonIcon +
              (currentTitle !== '请点击录音，跟读文本' ? less.hidden : '')
            }
            onClick={() => startRecognise()}
          >
            <Icon
              type="audio"
              className={
                currentTitle !== '请点击录音，跟读文本' ? less.hidden : ''
              }
            />
          </div>
        </div>
        <div
          className={
            less.recording + ' ' + (recordingStatus !== 1 ? less.hidden : '')
          }
        >
          <Recorder
            recordingStatus={recordingStatus}
            setRecordingStatus={setRecordingStatus}
            setProgressList={setProgressList}
            setCurrentTitle={setCurrentTitle}
            setAudioUrl={setAudioUrl}
            setNewActiveText={setNewActiveText}
            recoderRef={AudioRef}
            language={language}
            activeText={activeText}
            type={'GeneralSpeech'}
            setGeneralSpeechAudioDuration={setGeneralSpeechAudioDuration}
          />
        </div>
        {currentTitle === '评测结果' && (
          <div className={less.recordingPlay}>
            <div className={less.audio}>
              <div
                className={
                  less.audioBtn +
                  ' ' +
                  (audio.isPausing ? less.audioBtnPadding : '')
                }
                onClick={() => audioControlHandle()}
              >
                <Icon type={audio.isPausing ? 'caret-right' : 'pause'} />
              </div>
              <audio src={audioUrl} ref={audio.ref} />
              <Progress
                percent={progressPercent}
                showInfo={false}
                strokeWidth={7}
                strokeColor="#B6B6B6"
                trailColor="#F1F1F1"
                className={less.progressPercent}
              />
            </div>
            <div className={less.audioTime}>
              {currentTimes}/
              {moment(generalSpeechAudioDuration).format('mm:ss')}
            </div>
            <button
              type="button"
              className={less.button}
              onClick={() => startRecognise()}
            >
              再试一次
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default GeneralSpeechEvaluationItem;
